import mustache from "mustache";
import { CardBody } from "../../definitions/card/CardBody";
import { CardFooter } from "../../definitions/card/CardFooter";
import { CardHeader } from "../../definitions/card/CardHeader";
import { IConnectRender } from "../../definitions/IConnectRender";
import template from "./template.html";

mustache.parse(template);

type CardData = {
  additionalCssClass: string;
  cardId: number;
  header: CardHeader;
  body: CardBody;
  footer: CardFooter | null;
};

let CARD_ID = 0;

export abstract class CardConnectRender implements IConnectRender {
  protected readonly _cardId: number;

  constructor() {
    CARD_ID += 1;
    this._cardId = CARD_ID;
  }

  protected _additionalCardCssClass: string = "";

  protected abstract getCardHeader(): CardHeader;

  protected _backAction?: () => void;

  protected abstract getCardBody(): CardBody;

  protected abstract getCardFooter(): CardFooter | null;

  protected abstract afterConnect(): void;

  protected abstract beforeDispose(): void;

  protected _disposed: boolean = false;

  render(): string {
    this._data = {
      additionalCssClass: this._additionalCardCssClass,
      body: this.getCardBody(),
      cardId: this._cardId,
      header: this.getCardHeader(),
      footer: this.getCardFooter(),
    };
    return mustache.render(template, this._data);
  }

  connect(): void {
    if (!this._data) throw new Error("Debe llamar primero render.");

    this._cardBack = document.getElementById(
      `card-back-${this._cardId}`,
    ) as HTMLButtonElement;
    if (this._backAction) {
      this._cardBack.addEventListener("click", this._backAction);
    } //
    else {
      this._cardBack.remove();
    }

    this._cardFooter = document.getElementById(
      `card-footer-${this._cardId}`,
    ) as HTMLDivElement;
    if (!this._data.footer) {
      this._cardFooter.remove();
      this._cardFooter = null;
    }

    this.afterConnect();
  }

  dispose(): void {
    if (this._disposed) return;

    this.beforeDispose();
    this._card?.remove();
    this._disposed = true;
  }

  private _data: CardData | null = null;
  private _card: HTMLDivElement | null = null;
  private _cardBack: HTMLButtonElement | null = null;
  private _cardFooter: HTMLDivElement | null = null;
}
